import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const CommunicationPanel = () => {
  const [newMessage, setNewMessage] = useState('');
  const [messages, setMessages] = useState([
  {
    id: 1,
    sender: "João Silva",
    role: "Técnico",
    avatar: "https://images.unsplash.com/photo-1628479104885-c21cbb899f54",
    avatarAlt: "Professional headshot of young man with short brown hair wearing blue collared shirt",
    message: "Manutenção preventiva concluída no servidor principal. Todos os sistemas estão operacionais.",
    timestamp: "31/10/2024 14:30",
    type: "update"
  },
  {
    id: 2,
    sender: "Maria Santos",
    role: "Gerente de Projeto",
    avatar: "https://images.unsplash.com/photo-1706565029882-6f25f1d9af65",
    avatarAlt: "Professional headshot of woman with long dark hair wearing white blazer",
    message: "Relatório mensal de progresso disponível. O projeto está 15% acima do cronograma planejado.",
    timestamp: "31/10/2024 11:15",
    type: "report"
  },
  {
    id: 3,
    sender: "Carlos Oliveira",
    role: "Técnico",
    avatar: "https://images.unsplash.com/photo-1585066047759-3438c34cf676",
    avatarAlt: "Professional headshot of middle-aged man with beard wearing dark suit",
    message: "Agendamento confirmado para instalação de novos equipamentos na próxima terça-feira às 09:00.",
    timestamp: "30/10/2024 16:45",
    type: "schedule"
  },
  {
    id: 4,
    sender: "Ana Costa",
    role: "Suporte Técnico",
    avatar: "https://images.unsplash.com/photo-1622113699726-a2d384585887",
    avatarAlt: "Professional headshot of young woman with blonde hair wearing navy blue top",
    message: "Solicitação #2024-015 foi resolvida. Documentação atualizada no sistema.",
    timestamp: "30/10/2024 13:20",
    type: "resolution"
  }]
  );

  const handleSendMessage = () => {
    if (newMessage?.trim()) {
      const message = {
        id: messages?.length + 1,
        sender: "Você",
        role: "Cliente",
        avatar: null,
        avatarAlt: "Client user avatar placeholder",
        message: newMessage,
        timestamp: new Date()?.toLocaleString('pt-BR'),
        type: "client"
      };
      setMessages([message, ...messages]);
      setNewMessage('');
    }
  };

  const getMessageIcon = (type) => {
    switch (type) {
      case 'update':
        return 'CheckCircle';
      case 'report':
        return 'FileText';
      case 'schedule':
        return 'Calendar';
      case 'resolution':
        return 'CheckCircle2';
      case 'client':
        return 'MessageSquare';
      default:
        return 'MessageCircle';
    }
  };

  const getMessageColor = (type) => {
    switch (type) {
      case 'update':
        return 'text-success';
      case 'report':
        return 'text-primary';
      case 'schedule':
        return 'text-warning';
      case 'resolution':
        return 'text-success';
      case 'client':
        return 'text-accent';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-card-foreground">Comunicações Recentes</h3>
          <Button variant="ghost" size="sm" iconName="MessageSquare">
            Ver Todas
          </Button>
        </div>
      </div>
      <div className="p-4">
        {/* Message Input */}
        <div className="mb-4">
          <div className="flex space-x-2">
            <Input
              placeholder="Digite sua mensagem..."
              value={newMessage}
              onChange={(e) => setNewMessage(e?.target?.value)}
              onKeyPress={(e) => e?.key === 'Enter' && handleSendMessage()}
              className="flex-1" />

            <Button
              onClick={handleSendMessage}
              disabled={!newMessage?.trim()}
              iconName="Send"
              size="icon" />

          </div>
        </div>

        {/* Messages List */}
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {messages?.map((message) =>
          <div key={message?.id} className="flex space-x-3">
              <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center flex-shrink-0">
                {message?.avatar ?
              <img
                src={message?.avatar}
                alt={message?.avatarAlt}
                className="w-full h-full rounded-full object-cover" /> :


              <Icon name="User" size={18} className="text-muted-foreground" />
              }
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 mb-1">
                  <span className="font-medium text-sm text-card-foreground">
                    {message?.sender}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {message?.role}
                  </span>
                  <Icon
                  name={getMessageIcon(message?.type)}
                  size={14}
                  className={getMessageColor(message?.type)} />

                  <span className="text-xs text-muted-foreground">
                    {message?.timestamp}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">
                  {message?.message}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default CommunicationPanel;